"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.executeStrategiesWithCache = exports.executeStrategies = void 0;
const implementedStrategies = __importStar(require("./strategies"));
const required_1 = require("../helpers/required/required");
const cacheStrategyWrapper_1 = require("../helpers/cacheWrapper/cacheStrategyWrapper");
const camelCase = require('camelcase');
const cacheWrapper = new cacheStrategyWrapper_1.CacheStrategyWrapper();
exports.executeStrategies = (strategies, tokenId = '0', cache = false) => __awaiter(void 0, void 0, void 0, function* () {
    // Checking all strategies exist
    strategies
        .forEach(orStrategies => orStrategies.forEach(strategy => {
        const camelCaseName = camelCase(strategy.name);
        required_1.requiredDefined(implementedStrategies[camelCaseName], `this strategy does not exist ${strategy.name}`);
    }));
    const strategiesResults = yield Promise.all(strategies
        .map(orStrategy => {
        return Promise.all(orStrategy.map(strategy => {
            required_1.requiredDefined(strategy.name, `name is not defined, ${strategy}`);
            const camelCaseName = camelCase(strategy.name);
            // remove null and undefined adresses
            strategy.addresses = strategy.addresses ? strategy.addresses.filter(d => d) : [];
            strategy.tokenId = tokenId;
            const factoryFunc = () => implementedStrategies[camelCaseName](strategy);
            if (cache) {
                return cacheWrapper.execute(strategy, factoryFunc);
            }
            else {
                return factoryFunc();
            }
        }));
    }));
    let isAuthorized = false;
    for (var strategyResult of strategiesResults) {
        const isStrategyAuthorized = strategyResult.map(d => d.isAuthorized).includes(false) === false;
        if (isStrategyAuthorized) {
            isAuthorized = isStrategyAuthorized;
            break;
        }
    }
    isAuthorized = strategiesResults.length === 0 ? true : isAuthorized;
    return {
        isAuthorized,
        strategies: strategiesResults
    };
});
exports.executeStrategiesWithCache = (strategies, tokenId = '0') => exports.executeStrategies(strategies, tokenId, true);
//# sourceMappingURL=executeStrategy.js.map